import { FC } from 'react'
import { TBlogPostResult } from 'common/cms-types'
import Link from 'next/link'
import { linkResolver } from '../../linkResolver'
import { Query } from '@prismicio/types'
import Carousel from 'components/Carousel'
import Card from 'components/cards/base/Card'
import Heading from 'components/Heading'
import Button from 'components/forms/Button'
import imageResize from 'project/image-proxy-web'

type RelatedArticleType = {
  posts: Query<TBlogPostResult>
}

const BlogCarousel: FC<RelatedArticleType> = ({ posts }) => {
  if (!posts?.results?.length) return null
  return (
    <>
      <div className='blog-container overflow-x-hidden mt-xl-14 mt-4'>
        <Carousel uncontrolled slideClass={'blog-item__container'}>
          {posts.results.map((post) => (
            <Link
              className='a-unstyled'
              href={linkResolver(post as any)}
              key={post.id}
            >
              <>
                <div className='card cursor-pointer bg-white'>
                  <div className={'blog-carrousel-image'}>
                    <img
                      loading='lazy'
                      className='img-fluid h-auto'
                      src={imageResize(post.data.main_image.url, 816, 544)}
                      // src={post.data.main_image.url}
                      alt={`${post.data.main_image.alt}`}
                      height={544}
                      width={816}
                    />
                  </div>
                  <div className='blog-item__content'>
                    <span className='lead color-grey5 d-none d-lg-block'>
                      {post.data.modified_date}
                    </span>
                    <Heading
                      className='h4 h4--mobile-small text-semibold pr-5 mb-0 '
                      size={3}
                    >
                      {post.data.title}
                    </Heading>
                    <span className='lead color-grey5 d-block d-lg-none'>
                      {post.data.modified_date}
                    </span>
                  </div>
                </div>
              </>
            </Link>
          ))}
        </Carousel>
      </div>
      <div className='d-flex justify-content-center'>
        <Link className='a-unstyled' href='/blog'>
          <Button className='mt-6 mb-md-8' size={'medium'} theme='secondary'>
            Check out our blog
          </Button>
        </Link>
      </div>
    </>
  )
}

export default BlogCarousel
